import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
/**
 * @namespace Expression
 * @memberOf Qualifiers.Expression
 * @extends {SDK.QualifierValue}
 */
class ExpressionQualifier extends QualifierValue {
    constructor(value) {
        super();
        this.value = value;
    }
    toString() {
        return this.value;
    }
}
export { ExpressionQualifier };
